import baseAPI from '@/http'

const router = 'api/usuario/usuario'

export const usuarioAPI = {
  create: usuario => baseAPI.post(router, usuario),
  update: usuario => baseAPI.put(router, usuario),
  get: id => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(`${router}`),
  delete: id => baseAPI.delete(`${router}/${id}`),
  usuariosCadastrados: () => baseAPI.get(`${router}/usuarios-cadastrados`),
  listUsuariosCadastrados: () => baseAPI.get(`${router}/list-usuarios-cadastrados`),
  compradores: term => baseAPI.get(`${router}/compradores/${term}`),
  compradoresFiltro: filtro =>
    baseAPI.post(`${router}/compradores/filtro`, filtro),
  recuperarSenha: usuario => baseAPI.post(`${router}/recuperar-senha`, usuario),
  trocarSenha: usuario => baseAPI.post(`${router}/trocar-senha`, usuario),
  existeEmail: usuario => baseAPI.post(`${router}/existe-email`, usuario),
  existeTelefone: usuario => baseAPI.post(`${router}/existe-telefone`, usuario),
  existeCPF: usuario => baseAPI.post(`${router}/existe-cpf`, usuario),
  existeCNPJ: usuario => baseAPI.post(`${router}/existe-cnpj`, usuario),
  contato: contato => baseAPI.post(`${router}/contato`, contato),
  produtores: () => baseAPI.get(`${router}/produtores`),
  usuarios: id => baseAPI.get(`${router}/usuarios/${id}`)
}
